<template>
    <div class="index notranslate">
        <v-header></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" >
            <van-steps active="0">
  <van-step>{{$t('orderList.methodAndTime')}}</van-step>
  <van-step>{{$t('orderList.customerInfo')}}</van-step>
  <van-step>{{$t('orderList.confirmOrder')}}</van-step>
</van-steps>

            <mu-form :model="tableOrderInfo" class="mu-demo-form" label-position="top" style="width:90%;margin:0 auto;margin-top:20px;">
                <mu-form-item prop="DeliveryType" :label="$t('orderList.deliveryType')" style="margin-bottom:10px;">
                    <mu-radio v-model="deliveryType"  value="1" :label="$t('orderList.pickUp')"></mu-radio>
                    <br> <br> <br> <br>
                    <mu-radio v-model="deliveryType"  value="2" :label="$t('orderList.delivered')"></mu-radio>
                </mu-form-item>
                <br>
                <mu-form-item :label="$t('orderList.orderDate')" prop="date">
                <mu-select label="" v-model="tableOrderInfo.date" full-width @change="getDateTime">
                    <mu-option v-for="option,index in optionsDate" :key="index" :label="option.label" :value="option.value"></mu-option>
                </mu-select>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.orderTime')" prop="time">
                <mu-select label="" v-model="tableOrderInfo.time" full-width>
                    <mu-option v-for="option,index in optionsTime" :key="index" :label="option" :value="option"></mu-option>
                </mu-select>
                 </mu-form-item>
            </mu-form>
            <mu-list style="background-color: #fff; height: 60px; padding-top: 20px;padding-left: 20px;" v-if="deliveryPromptShow">
                <mu-checkbox v-model="chkPromise"  :label="configsData.DeliveryTimePrompt"></mu-checkbox>
            </mu-list>
        </mu-container>


        <div class="oprations">
                <div class="oprations-btn">
                    <div class="oprations-back" @click="jumpBack">{{$t('common.back')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="next">{{$t('common.submit')}}</div>
                </div>
            </div>
    </div>
</template>
<script>
    import header from '../components/TakeawayHeader';
    export default {
        name: 'Cart',
        data() {
            return {
                tableOrderInfo: {},
                seller:{},
                deliveryType:"1",
                configsData:{},
                optionsDate:[],
                chkPromise: true,
                deliveryPromptShow:false,
                optionsAllTime : ["07:00-07:15", "07:30-08:00", "08:00-08:15", "08:15-08:30", "08:30-08:45", "08:45-09:00", "09:00-09:15", "09:15-09:30", "09:30-09:45", "09:45-10:00", "10:00-10:15", "10:15-10:30", "10:30-10:45", "10:45-11:00", "11:00-11:15", "11:15-11:30", "11:30-11:45", "11:45-12:00", "12:00-12:15", "12:15-12:30", "12:30-12:45", "12:45-13:00",
                "13:00-13:15", "13:15-13:30", "13:30-13:45", "13:45-14:00", "14:00-14:15", "14:15-14:30", "14:30-14:45", "14:45-15:00", "15:00-15:15",
                "15:15-15:30", "15:30-15:45", "15:45-16:00", "16:00-16:15", "16:15-16:30", "16:30-16:45", "16:45-17:00", "17:00-17:15", "17:15-17:30", "17:30-17:45",
                "17:45-18:00", "18:00-18:15", "18:15-18:30", "18:30-18:45", "18:45-19:00", "19:00-19:15", "19:15-19:30", "19:30-19:45", "19:45-20:00", "20:00-20:15",
                "20:15-20:30", "20:30-20:45", "20:45-21:00", "21:00-21:15", "21:15-21:30", "21:30-21:45", "21:45-22:00"],
                optionsTime:[],
                bankTimes:[],
            }
        },
        computed: {
            payClass() {
                this.unPayTip = '';
                return false;
            }
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            var now = new Date();
            this.tableOrderInfo.date=now.getFullYear() + "-" + this.dataLen(now.getMonth() + 1) + "-" + this.dataLen(now.getDate())
            this.getConfigs();
            this.getDate();
            this.getBank();
        },
        methods: {
            getConfigs() {
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                            this.deliveryPromptShow=true;
                        }
                    });
            },
            getBank() {
                this.$get('QRCodeOrder/GetRestaurantBanById', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            this.bankTimes=response.data;
                            this.getDateTime();
                        }
                    });
            },
            getHourNum(hoursStr) {
                var arr = hoursStr.split(':');
                return parseInt(arr[0]);
            },
            getDateTime(){
                var beginHour = 7, endHour = 22;
            if (this.tableOrderInfo.date != null && this.tableOrderInfo.date != '') {
                    let p=new Date(this.tableOrderInfo.date).getDay();
                    beginHour = this.getHourNum(this.bankTimes[p].beginTime);
                    endHour = this.getHourNum(this.bankTimes[p].endTime);
                }
                let resurtantTimeArr = [];
                for (var m in this.optionsAllTime) {
                        var hour = this.getHourNum(this.optionsAllTime[m]);
                        if (hour >= beginHour && hour < endHour) {
                            resurtantTimeArr.push(this.optionsAllTime[m]);
                        }
                    }
                var timeArr = new Array();
                if (new Date(this.tableOrderInfo.date).toDateString() === new Date().toDateString()) {
                var myDate = new Date();
                var h = myDate.getHours();
                var m = myDate.getMinutes();
                if (parseInt(m) >= 45) { h = h + 1 }
                for (var x in resurtantTimeArr) {
                    var val = resurtantTimeArr[x];
                    var ha = val.substr(0, 2);
                    var ma = val.substr(3, 2);
                    if (parseInt(ha) == parseInt(h)) {
                        if (parseInt(ma) >= parseInt(m) || parseInt(m) >= 45) {
                            timeArr.push(val);
                        }
                    }
                    else if (parseInt(ha) > parseInt(h)) {
                        timeArr.push(val);
                    }
                }
                this.optionsTime = timeArr;
            } else {
                this.optionsTime = resurtantTimeArr;
            }
            },
            dataLen(d) {
            if (d < 10) {
                return "0" + d;
            }
            return d;
        },
            getDate() {
            var d = new Date();
            var dateValueArr = new Array();
            var today = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
            for (var i = 0; i < 30; i++) {
                var d = new Date()
                d.setDate(d.getDate() + i);
                var week = today[d.getDay()];
                var d2 = this.dataLen(d.getDate()) + "-" + this.dataLen(d.getMonth() + 1) + "-" + d.getFullYear();
                dateValueArr.push({
                    label:(week + ' ' + d2),
                    value:(d.getFullYear() + "-" + this.dataLen(d.getMonth() + 1) + "-" + this.dataLen(d.getDate()))
                });
            }
                this.optionsDate=dateValueArr;
            },
            jumpBack() {
                this.$router.go(-1);
            },
            next(){
                if (!this.chkPromise) {
                    this.$alert(this.$t("orderList.agreeWait"), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                    return;
                }
                if(this.deliveryType==null){
                    this.$alert(this.$t("orderList.deliveryTypeNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                this.tableOrderInfo.deliveryType=this.deliveryType;
                if(this.tableOrderInfo.date==undefined||this.tableOrderInfo.date==null){
                    this.$alert(this.$t("orderList.dateNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.time==undefined||this.tableOrderInfo.time==null){
                    this.$alert(this.$t("orderList.timeNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                var timeArr=this.tableOrderInfo.time.split('-');
                this.tableOrderInfo.orderTime=this.tableOrderInfo.date+" "+timeArr[0]+":00";
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                this.$router.push({ path: '/takwawayCustomer', query: { } });
            },
            getPath() {
                if (this.$route.path == '/takwawayInfo') {
                    this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                    if(this.tableOrderInfo.date==null){
                        var now = new Date();
                        this.tableOrderInfo.date=now.getFullYear() + "-" + this.dataLen(now.getMonth() + 1) + "-" + this.dataLen(now.getDate())         
                    }
                }
            },
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            'v-header': header
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 0px;
    }

    .mu-raised-button .mu-button-wrapper {
        padding: 0 12px;
    }

    .mu-button {
        text-transform: unset;
    }

        .mu-button .mu-icon-left {
            margin-right: 3px;
        }

    .material-icons {
        font-size: 12px;
    }

    .content {
        /*  background-image: url(../assets/image/background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;*/
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 14px;
        color: #4fc3f7;
    }

    .cart-opration {
        float: right;
        right: 10px;
        position: absolute;
    }

    .cart-opration-btn {
        width: 36px;
        height: 36px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding: 0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 36px;
        min-width: unset;
        top: -2px;
    }

    .btn-refresh {
        position: fixed;
        right: 10px;
        background-color: #757575 !important;
        z-index: 10;
    }

    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }

    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }

    .btn-refresh {
        position: fixed;
        bottom: 10px;
        left: 10px
    }

    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }

    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    
    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right:0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }
            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width:100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 100%;
            }

        .oprations .oprations-btn .oprations-next.not-enough {
            background: #2b333b;
        }

        .oprations .oprations-btn .oprations-next.enough {
            background: #00b43c;
            color: #fff;
        }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }
</style>



// WEBPACK FOOTER //
// src/components/TakwawayInfo.vue